import { Link } from 'react-router-dom';
import { articlesByCategory } from '@/mocks/articles';

export default function CommunitySection() {
  const communityPosts = articlesByCategory('community').slice(0, 2);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="community-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">FAN COMMUNITY</p>
            <h2 id="community-title" className="font-heading text-2xl md:text-3xl text-foreground-950">粉丝社区</h2>
          </div>
          <Link
            to="/category/community"
            className="flex items-center gap-1.5 text-sm text-secondary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            进入社区 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {communityPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/article/${post.slug}`}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="sm:w-56 shrink-0 h-40 sm:h-auto overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5">
                <span className="inline-block text-xs text-primary-500 font-medium bg-primary-50 px-2.5 py-0.5 rounded-full mb-3">
                  社区活动
                </span>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {post.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {post.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-primary-50 rounded-lg p-6 md:p-8 text-center">
          <h3 className="font-heading text-xl text-foreground-900 mb-3">加入佐佐木明希官方粉丝俱乐部</h3>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto mb-5 leading-relaxed">
            成为「明希会」会员，获取独家内容、优先购票权、限定周边与活动参与机会
          </p>
          <Link
            to="/category/community"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-heart-line"></i> 立即加入
          </Link>
        </div>
      </div>
    </section>
  );
}